import ApiService from "../api";

export default class FolhaPagamentoService extends ApiService {

    constructor() {
        super('/api/folha-pagamentos')
    }

    dashboardHorasExtras(values) {
        const {
            ano = null,
            mes = null,
            filialId = null,
        } = values;

        const params = new URLSearchParams();
        params.append("ano", ano);
        if (mes) params.append("mes", mes);
        if (filialId) params.append("filialId", filialId);

        return this.get(`/dashboard?${params}`);
    }

}